export const RAMED_ENABLED = false;
export const PROFILE_PLACEHOLDER = '../../../assets/images/profile.jpg';
